<template>
    <div class="agreement">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>协议管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>协议管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="协议编号">
                        <el-input v-model="searchForm.number" placeholder="协议编号" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="协议名称">
                        <el-input v-model="searchForm.name" placeholder="协议名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称">
                        <el-input v-model="searchForm.companyName" placeholder="公司名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="协议状态" size="mini" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="草稿" value="0"></el-option>
                            <el-option label="待审核" value="1"></el-option>
                            <el-option label="通过" value="2"></el-option>
                            <el-option label="驳回" value="3"></el-option>
                            <el-option label="生效" value="4"></el-option>
                            <el-option label="到期" value="5"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table size="mini" stripe
                    ref="dataTable"
                    :data="tableData"
                    :height="tableConfig.height"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column
                        prop="companyName"
                        label="公司名称">
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        label="协议编号">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="协议名称">
                        <template slot-scope="scope">
                             <a :href="scope.row.filePath" target="_blank">{{scope.row.name}}</a>
                         </template>
                    </el-table-column>
                    <el-table-column
                        prop="startTime"
                        label="协议生效时间"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="endTime"
                        label="协议失效时间"
                        width="120">
                    </el-table-column>
                     <el-table-column
                             prop="status"
                             label="状态"
                             width="80">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 0" disable-transitions>草稿</el-tag>
                            <el-tag v-else-if="scope.row.status === 1" type="warning" disable-transitions>待审核</el-tag>
                            <el-tag v-else-if="scope.row.status === 2" type="info" disable-transitions>通过</el-tag>
                            <el-tooltip v-else-if="scope.row.status === 3" class="item" effect="dark" :content="scope.row.rejectReason" placement="top">
                                <el-tag type="danger" disable-transitions>驳回</el-tag>
                            </el-tooltip>
                            <el-tag v-else-if="scope.row.status === 4" type="success" disable-transitions>生效</el-tag>
                            <el-tag v-else-if="scope.row.status === 5" type="info" disable-transitions>到期</el-tag>
                         </template>
                     </el-table-column>
                    <el-table-column label="操作" width="420" align="right">
                        <template slot="header">
                            <el-button type="primary" @click="handleCreateAgreement" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status == 0 || scope.row.status == 3"
                                    size="mini" type="text"
                                    @click="handleEditPrice(scope.$index, scope.row)">录入协议价格</el-button>
                            <el-divider direction="vertical" v-if="scope.row.status == 0 || scope.row.status == 3"></el-divider>
                            <el-button v-if="scope.row.status != 0 && scope.row.status != 3"
                                    size="mini" type="text"
                                    @click="handleViewPrice(scope.$index, scope.row)">查看协议价格</el-button>
                            <el-divider direction="vertical" v-if="scope.row.status != 0 && scope.row.status != 3"></el-divider>
                            <el-button type="text"
                                size="mini" :disabled="scope.row.status != 0 && scope.row.status != 3"
                                @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
                            <el-divider direction="vertical" v-if="$store.state.userInfo.review"></el-divider>
                            <el-dropdown size="mini" v-if="$store.state.userInfo.review">
                                <div style="">
                                     <span class="el-dropdown-link" style="font-size: 12px;vertical-align: middle;line-height: 28px;" >
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                  </span>
                                </div>

                                <el-dropdown-menu slot="dropdown">

                                    <el-dropdown-item>
                                        <el-button v-if="$store.state.userInfo.review" type="text"
                                                   size="mini" :disabled="scope.row.status != 0 && scope.row.status != 3"
                                                   @click="handlePublish(scope.$index, scope.row)" style="width: 100%;text-align: left;">提交</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button v-if="$store.state.userInfo.review" type="text"
                                                   size="mini" :disabled="scope.row.status != 1"
                                                   @click="handlePass(scope.$index, scope.row)" style="width: 100%;text-align: left;">通过</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button v-if="$store.state.userInfo.review"
                                                   size="mini" :disabled="scope.row.status != 1" type="text"
                                                   @click="handleReject(scope.$index, scope.row)" style="width: 100%;text-align: left;">驳回</el-button>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

<!--                            <el-button v-if="$store.state.userInfo.review" type="text"-->
<!--                                size="mini" :disabled="scope.row.status != 0 && scope.row.status != 3"-->
<!--                                @click="handlePublish(scope.$index, scope.row)">提交</el-button>-->
<!--                            <el-button v-if="$store.state.userInfo.review" type="text"-->
<!--                                size="mini" :disabled="scope.row.status != 1"-->
<!--                                @click="handlePass(scope.$index, scope.row)">通过</el-button>-->
<!--                            <el-button v-if="$store.state.userInfo.review"-->
<!--                                size="mini" :disabled="scope.row.status != 1" type="text"-->
<!--                                @click="handleReject(scope.$index, scope.row)">驳回</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="协议信息" :visible.sync="editDialogVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="110px">
                <el-form-item label="公司名称" prop="companyId">
                    <el-select v-model="editForm.companyId" filterable placeholder="请选择公司名称" clearable>
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="协议编号" prop="number">
                    <el-input v-model="editForm.number" placeholder="请输入协议编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="协议名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入协议名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="协议生效时间" prop="startTime">
                    <el-date-picker
                            v-model="editForm.startTime"
                            type="date"
                            placeholder="协议生效时间" value-format="yyyy-MM-dd"
                            clearable
                            >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="协议失效时间" prop="endTime">
                    <el-date-picker
                            v-model="editForm.endTime"
                            type="date"
                            placeholder="协议失效时间" value-format="yyyy-MM-dd"
                            clearable
                            >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="上传协议文件">
                    <el-upload
                            action="/api/admin/upload"
                            :limit="1"
                            :before-upload="beforeUploadFile"
                            :on-change="fileChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList">
                        <el-button size="small" plain>选择文件</el-button>
                        <div slot="tip">文件不超过100M</div>
                    </el-upload>
                    <el-input v-model="editForm.filePath" v-show="false" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="驳回原因" :visible.sync="rejectDialogVisible" :close-on-click-modal="false" width="300px">
            <el-form ref="rejectForm" :model="rejectForm" :rules="rules">
                <el-form-item prop="rejectReason">
                    <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 20}" v-model="rejectForm.rejectReason" placeholder="请输入驳回原因" maxlength="100" show-word-limit clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rejectDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onReject">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// import Template from '../property/Template.vue';
import { KeepAliveTableMixins } from '../../mixin/KeepAliveTable';
const HEIGHT_OFFSET = 118;
export default {
    mixins: [KeepAliveTableMixins],
//   components: { Template },

    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {
                number: "",
                name: "",
                companyName: "",
                status: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            uploadDialogVisible: false,
            fileList: [],
            editForm: {
                id: "",
                companyId: "",
                number: "",
                name: "",
                startTime: "",
                endTime: "",
                url: "",
                filePath: "",
                file:"",
            },
            options: [],
            rejectDialogVisible: false,
            rejectForm: {
                id: "",
                rejectReason: "",
            },
            rules: {
                companyId: [
                    { required: true, message: '请选择公司', trigger: 'blur' }
                ],
                number: [
                    { required: true, message: '请输入协议编号', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入协议名称', trigger: 'blur' }
                ],
                userId: [
                    { required: true, message: '请选择用户', trigger: 'blur' }
                ],
                startTime: [
                    { required: true, message: '请选择生效时间', trigger: 'blur' }
                ],
                endTime: [
                    { required: true, message: '请选择失效时间', trigger: 'blur' }
                ],
                rejectReason: [
                    { required: true, message: '请填写驳回原因', trigger: 'blur' }
                ]
            },
        }
    },
    methods: {
        onSearch() {
            const { status } = this.searchForm;

            this.loading = true;
            let _this = this
            this.$axios.post("/admin/agreement/search",{
                cond: {...this.searchForm, status: status ? status : undefined},
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        handleCreateAgreement() {
            this.editForm.id = "";
            this.editForm.companyId = "";
            this.editForm.number = "";
            this.editForm.name = "";
            this.editForm.startTime = "";
            this.editForm.endTime = "";
            this.editForm.filePath = "";
            this.editDialogVisible = true;
        },
        onSubmit() {
            let _this = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/agreement/save", this.editForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.editDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEditPrice(index, row) {
            this.$router.push({name: "agreementdetail", params: {from: "agreement", agreementId: row.id, action: 'edit',title:'协议价格录入'}})
        },
        handleViewPrice(index, row) {
            this.$router.push({name: "agreementdetail", params: {from: "agreement", agreementId: row.id,title:'协议价格列表', action: 'view'}})
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.companyId = row.companyId;
            this.editForm.number = row.number;
            this.editForm.name = row.name;
            this.editForm.startTime = row.startTime;
            this.editForm.endTime = row.endTime;
            this.editForm.filePath = row.filePath;
            this.editDialogVisible = true;
        },
        handleUpload(index, row) {
            this.editForm.id = row.id;
            this.uploadDialogVisible = true;
        },
        handlePass(index, row) {
            let that = this;
            this.$axios.get("/admin/agreement/pass/"+row.id)
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '审核通过',
                        type: 'success'
                    });
                    that.onSearch();
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        handleReject(index, row) {
            this.rejectForm.id = row.id;
            this.rejectForm.rejectReason = "";
            this.rejectDialogVisible = true;
        },
        onReject() {
            let that = this;
            this.$refs.rejectForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/agreement/reject", this.rejectForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                that.$notify({
                                    title: '成功',
                                    message: '申请已拒绝',
                                    type: 'success'
                                });
                                that.rejectDialogVisible = false;
                                that.onSearch();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        handlePublish(index, row) {
            let that = this;
            this.$axios.get("/admin/agreement/publish/"+row.id)
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '数据已提交',
                        type: 'success'
                    });
                    that.onSearch();
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        // 文件状态改变时的钩子
        fileChange(file) {
            this.editForm.file = file.raw
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {
            let size = file.size / 1024 / 1024
            if(size > 100) {
                this.$notify.warning({
                    title: '警告',
                    message: `文件大小不得超过100M`
                });
            }
        },
        // 文件上传成功时的钩子
        handleSuccess(res, file) {
            this.$notify.success({
                title: '成功',
                message: `文件上传成功`
            });
            if (file.response.data.success) {
                this.editForm.filePath = file.response.data.message; //将返回的文件储存路径赋值picture字段
            }
        },
        // 文件上传失败时的钩子
        handleError() {
            this.$notify.error({
                title: '错误',
                message: `文件上传失败`
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }

    },

    created() {
        const that = this;
        this.$axios.post("/admin/company/list", {})
        .then(function(response) {
            const resp = response.data;
            if(resp.header.status == 0) {
                that.options = resp.data;
                that.onSearch();
            }
        }).catch(function() {
        });
        window.addEventListener("resize", this.setTableHeight);
        // console.log(this.$store.getters.getUserInfo);

    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }

    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    },
}
</script>
<style>
</style>
